import { ZkTracking, AmplitudeTracking, AbstractTracking } from '@zk/framework-vue';
import Proxy from 'es6-proxy-polyfill';
import Vue from 'vue';
class NoneTracking extends AbstractTracking {
  send() {}
  identity() {}
  setUserInfo() {}
  logout() {}
}

const noneTracking = new NoneTracking();
// 如果不是生产环境则开启日志
const isOpenLog = config => config.VUE_APP_ENV && !['prod', 'sit'].includes(config.VUE_APP_ENV);

const getTracking = async (Vue, config, options, project) => {
                
  // eslint-disable-next-line
           if(true) return new ZkTracking(noneTracking, options);
  // eslint-disable-next-line
           
  // eslint-disable-next-line
  class PosthogTracking extends AbstractTracking {
    send(event, data) {
      return this.target.capture(event, data);
    }

    identify(id, extData) {
      let idStr = id.toString();
      if (idStr.length < 5) {
        idStr = idStr.padStart(5, '0');
      }
      this.target.identify(idStr, {
        userId: idStr,
        env: config.VUE_APP_ENV,
        ...(extData || {})
      });
    }

    setUserInfo(info) {
      this.target.setPersonProperties(info);
    }

    logout() {
      this.target.reset?.();
    }
  }
  class AmplitudeAndPosthogTracking extends AbstractTracking {
    constructor(amplitude, posthog) {
      super(null, null);
      this.amplitudeInstance = new AmplitudeTracking(amplitude);
      if (posthog) {
        this.posthogInstance = new PosthogTracking(posthog);
      }
    }
    send(event, data) {
      this.amplitudeInstance.send(event, data);
      this.posthogInstance?.send(event, data);
    }

    identify(id, extData) {
      this.amplitudeInstance.identify(id, extData);
      this.posthogInstance?.identify(id, extData);
    }

    setUserInfo(info) {
      this.amplitudeInstance.setUserInfo(info);
      this.posthogInstance?.setUserInfo(info);
    }

    logout() {
      this.amplitudeInstance.logout();
      this.posthogInstance?.logout();
    }
  }
  const currentPageTrackingEnrichment = () => {
    return {
      name: 'current-page-tracking-enrichment',
      type: 'enrichment',
      setup: async () => undefined,
      execute: async (event) => {
        event.event_properties = {
          ...event.event_properties,
          current_url: window.location.href,
          current_path: window.location.pathname || '/'
        };
        return event;
      }
    };
  };
  const amplitude = (await import('@amplitude/analytics-browser'));
  const isUseTracking = config.VUE_APP_TRACKING === '1' || config.VUE_APP_TRACKING === 'true' || config.VUE_APP_TRACKING === true;
  const isOpenDev = ['prod', 'pre'].includes(config.VUE_APP_ENV);
  if (isUseTracking && (project ? isOpenDev : true) && amplitude && amplitude.init) {
    const amplitudeInstance = amplitude;
    const serverUrlMap = {
      'https://liga.cn': 'https://apm.ligai.cn',
      'https://pre.leiga.net': 'https://pre-apm.leiga.net',
      'https://sit2.leiga.net': 'https://sit2-apm.leiga.net',
      'https://app-sit2.leigaqa.com': 'https://sit2-apm.leigaqa.com',
      'https://app-pre.leigaqa.com': 'https://pre-apm.leigaqa.com',
      'https://app.leiga.com': 'https://apm.leiga.com'
    };
    const url = serverUrlMap[location.origin];
    // eslint-disable-next-line spellcheck/spell-checker
    const serverUrl = url ? `${url}/2/httpapi` : 'https://api2.amplitude.com/2/httpapi';
    
    amplitudeInstance.add(currentPageTrackingEnrichment());
    amplitudeInstance.init(config.VUE_APP_ADD_AMPLITUDE_API_KEY, null, {
      serverUrl: serverUrl,
      flushIntervalMillis: 10000,
      flushQueueSize: 5,
      logLevel: isOpenLog(config) ? 'INFO' : 'WARN',
      defaultTracking: {
        pageViews: {
          trackHistoryChanges: 'pathOnly'
        }
      }
    });
    // posthog
    let posthogInstance;
    if (config.VUE_APP_POSTHOG_API_KEY) {
      let posthog = (await import('posthog-js'));
      posthog = posthog.default || posthog;
      posthogInstance = posthog.init(
        config.VUE_APP_POSTHOG_API_KEY,
        {
          api_host: config.VUE_APP_POSTHOG_API_HOST,
          ui_host: 'https://us.posthog.com',
          person_profiles: 'identified_only',
          capture_pageview: false,
          disable_session_recording: true,
          disable_surveys: true
        }
      );
      Vue.prototype.$posthog = posthogInstance;
    }
    return new ZkTracking(new AmplitudeAndPosthogTracking(amplitudeInstance, posthogInstance), options);
  }
  return noneTracking;
};

const bufferActions = [];
Vue.prototype.$track = new Proxy({}, {
  get(target, key) {
    if (['send', 'identity', 'setUserInfo', 'logout', 'ignoreTracking'].includes(key)) {
      return (...args) => {
        bufferActions.push({ key, args });
      };
    }
    return undefined;
  }
});

export default async (Vue, config, options, project) => {
  let $track = await getTracking(Vue, config, options, project);

  // 如果不是生产环境则开启日志
  if (isOpenLog(config)) {
    $track = new Proxy($track, {
      get(target, key) {
        if (key === 'send') {
          return (event, data, ...args) => {
            window.console.info(`tracking ${event} ==> ${JSON.stringify(data)}`);
            return Reflect.apply(target[key], target, [event, data, ...args]);
          };
        }
        return target[key];
      }
    });
  }
  Vue.prototype.$track = $track || noneTracking;

  try {
    if ($track && $track !== noneTracking) {
      $track.ignoreTracking = () => {
        $track.target = noneTracking;
      };
      bufferActions
        .filter(item => typeof $track[item.key] === 'function')
        .forEach(item => Reflect.apply($track[item.key], $track, item.args));
    }
  } catch (error) {
    console.warn('执行埋点缓存操作异常', error);
  }
  bufferActions.length = 0;
};
